import { useEffect, useState } from 'react';

export function useDebounce<T>(value: T, delay: number): T {
    //TODO: this can replace lodash debounce in some contexts
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);

    return debouncedValue;
} 